<div class="dialog-header" [class.bottom-border]="showBottomBorder()">
  <span class="dialog-title">{{ title() }}</span>
  <div
    class="x-icon-wrapper"
    (click)="closeClick()"
    (mousedown)="handleXIconClick()"
    (mouseup)="handleXIconRelease()"
    (mouseleave)="handleXIconRelease()"
    [class.clicked]="xIconClicked"
  >
    <lucide-icon [img]="X" class="dialog-close"></lucide-icon>
  </div>
</div>
